import request from "@/axios";

export const getGiftTypeList = query => {
  return request({
    url: "/lebo-partner/partnergift/page",
    method: "GET",
    params: {
      ...query
    }
  });
};
export const getGiftTypeOptions = () => {
  return request({
    url: "/lebo-partner/partnergift/list",
    method: "GET",
    params: {
      type: 1
    }
  });
};

export const getGiftList = query => {
  return request({
    url: "/lebo-partner/partnergiftrecord/page",
    method: "GET",
    params: {
      ...query
    }
  });
};

// 增加/编辑赠品类型
export const submitGiftTypeInfo = data => {
  return request({
    url: "/lebo-partner/partnergift/submit",
    method: "POST",
    data
  });
};

// 删除赠品类型
export const deleteGiftType = data => {
  return request({
    url: "/lebo-partner/partnergift/remove",
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    params: data
  });
};

// 增加/编辑赠品
export const submitGiftInfo = data => {
  return request({
    url: "/lebo-partner/partnergiftrecord/submit",
    method: "POST",
    data
  });
};

// 删除赠品
export const deleteGifts = data => {
  return request({
    url: "/lebo-partner/partnergiftrecord/remove",
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    params: data
  });
};

// 导出数据
export const exportGifts = query => {
  return request({
    url: "/lebo-partner/partnergiftrecord/export-record",
    method: "GET",
    params: {
      ...query
    }
  });
};

// 导入数据
export const importGifts = data => {
  return request({
    url: "/lebo-partner/partnergiftrecord/import-record",
    method: "POST",
    data
  });
};
// 导出模板
export const exportGiftsTemplate = () => {
  return request({
    url: "/lebo-partner/partnergiftrecord/export-template",
    method: "GET"
  });
};

// 获取非加密卷码
export const decode = id => {
  return request({
    url: "/lebo-partner/partnergiftrecord/unmask?id=" + id,
    method: "GET"
  });
};

// 获取活动列表数据
export const getActivityOptions = () => {
  return request({
    url: "/lebo-partner/partnergiftpromotion/simple-list",
    method: "GET"
  });
};

// 查询赠送记录分页
export const getGiftRecords = query => {
  return request({
    url: "/lebo-partner/partnergiftdelivery/page",
    method: "GET",
    params: {
      ...query
    }
  });
};
// 获取业务字典里的赠品类型
export const geDictGiftTypeList = () => {
  return request({
    url: "/lebo-system/dict-biz/dictionary",
    method: "get",
    params: {
      code: "GIFT_TYPE"
    }
  });
};

//获取联运商品已经生效的商品
export const getMemberGoods = () => {
  return request({
    url: "/lebo-member/web/union-member/goods/base",
    method: "get"
  });
};

/** 获取优惠券列表 */
export const getCouponList = () => {
  return request({
    url: "/lebo-member/web/coupon/page",
    method: "get",
    params: {
      current: 1,
      size: 999,
      expireStatus: 0,
      reviewStatus: 3
    }
  });
};
